import Vue from 'vue';

Vue.component('vuetable-audit-trail', () =>
    import(/* webpackChunkName: 'audit-trail-index' */ './audit-trail-index.vue'),
);

Vue.component('audit-access-control', () =>
    import(/* webpackChunkName: 'audit-trail-index' */ './access-control/audit-access-control-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/audit-trail/index.js